import React from "react";

import { Box } from "@mui/material";

import LoginImage from "@dashboard/assets/images/login/signIn.svg";
import IgfdBlackLogo from "@dashboard/assets/images/logo/logo-name-black.png";

export const SideAsset = () => {
  return (
    <Box
      sx={({ palette }) => ({
        backgroundColor: palette.success.main,
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
        height: "100%",
        gap: 24,
        minWidth: 400,
        maxWidth: "35%",
        flexGrow: 1,
      })}
    >
      <img
        style={{
          paddingTop: 24,
          marginLeft: 32,
          marginRight: 32,
          alignSelf: "center",
          position: "relative",
          width: 240,
          maxWidth: 240,
          objectFit: "cover",
        }}
        src={IgfdBlackLogo}
      />
      <img
        style={{
          paddingTop: 24,
          marginLeft: 32,
          marginRight: 32,
          alignSelf: "center",
          position: "relative",
          minWidth: 200,
          maxWidth: 240,
          objectFit: "cover",
        }}
        src={LoginImage}
      />
    </Box>
  );
};
